// 定义全局工具对象
document.addEventListener('DOMContentLoaded', function () {
  $.toolList = {
    /**
     * 动态渲染YouTube视频列表【列表的默认ID是 ytPlayListUl，iframe的默认ID是playlistVideo（如果是默认id，可不写）】
     * @param {Object} data - 包含播放列表数据的对象
     * @param {string} [IdName='ytPlayListUl'] - 播放列表容器的ID
     * @param {string} [videoIdName='playlistVideo'] - iframe容器的ID
     */
    createYTPlayEvent: function (data, IdName, videoIdName) {
      // 设置默认参数
      IdName = IdName || 'ytPlayListUl'
      videoIdName = videoIdName || 'playlistVideo'
      if (!data.playlist || data.playlist?.length === 0) {
        const element = document.getElementById('youtube-playlist-section')
        if (element) {
          element.remove() // 确保元素存在再删除
        } else {
          console.error('元素未找到！')
        }
      } else if (data.playlist) {
        // 设置第一个视频为默认播放
        const iframe = document.getElementById(videoIdName)
        if (iframe && data.playlist.length > 0) {
          iframe.src = 'https://www.youtube.com/embed/' + data.playlist[0].id
        }

        // 创建播放列表
        const ytPlayListUl = document.getElementById(IdName)
        const baseUrl = 'https://img.youtube.com/vi/'

        data.playlist.forEach(function (video) {
          const li = document.createElement('li')
          const img = document.createElement('img')

          img.src = baseUrl + video.id + '/maxresdefault.jpg'
          img.alt = video.title

          // 点击事件 - 切换视频
          img.onclick = function () {
            iframe.src = 'https://www.youtube.com/embed/' + video.id
          }

          // 图片加载失败或尺寸太小则使用备用图
          img.onload = function () {
            if (this.naturalWidth <= 120) {
              this.src = baseUrl + video.id + '/hqdefault.jpg'
            }
          }

          img.onerror = function () {
            this.src = baseUrl + video.id + '/hqdefault.jpg'
          }

          const titleContainer = document.createElement('div')
          titleContainer.className = 'title-container'
          titleContainer.innerHTML = '<p class="video-title">' + video.title + '</p>'

          li.appendChild(img)
          li.appendChild(titleContainer)
          ytPlayListUl.appendChild(li)
        })
      }
    },
    /**
     * 动态渲染BlogPost列表【默认ID是 featured-blogs-slider（如果是默认id，可不写）】
     * @param {Object} data - 包含播放列表数据的对象
     * @param {string} [IdName='featured-blogs-slider'] - 播放列表容器的ID
     */
    createBlogPostsEvent: function (data, IdName) {
      // 设置默认参数
      IdName = IdName || 'featured-blogs-slider'
      if (!data.blogPosts || data.blogPosts?.length === 0) {
        const element = document.getElementById('featured-blogs-section')
        if (element) {
          element.remove() // 确保元素存在再删除
        } else {
          console.error('元素未找到！')
        }
      } else if (data.blogPosts) {
        const slider = document.getElementById(IdName)
        if (slider) {
          data.blogPosts.forEach((post) => {
            const card = document.createElement('div')
            card.className = 'tiny-slider-item-general-1113 p-3'
            card.innerHTML = `
                  <div class="card">
                    <div class="card-image">
                      <img class="card-img-top" src="${post.image}" alt="">
                    </div>
                    <div class="card-body pb-5 mb-4">
                      <h5 class="card-title font-weight-bold">${post.title}</h5>
                      <hr>
                      <h6 class="font-weight-bold text-muted">by ${post.author} <span class="ml-2 font-weight-normal">${post.date}</span></h6>
                      <div class="position-absolute w-100 text-left" style="bottom:1rem">
                        <p class="d-inline-block btn-underline text-uppercase mt-3 pb-0">Read More <i class="fas fa-chevron-right"></i></p>
                      </div>
                    </div>
                    <a href="${post.url}" target="_blank" class="position-absolute w-100 h-100 pb-3"></a>
                  </div>
                `
            slider.appendChild(card)
          })
        }
      }
    },
    /**
     * 动态渲染Support列表【默认ID是 accordion（如果是默认id，可不写）】
     * @param {Object} data - 包含播放列表数据的对象
     * @param {string} [IdName='accordion'] - 播放列表容器的ID
     */
    createSupportsEvent: function (data, IdName) {
      // 设置默认参数
      IdName = IdName || 'accordion'
      if (!data.supports || data.supports?.length === 0) {
        const element = document.getElementById('support-section')
        if (element) {
          element.remove() // 确保元素存在再删除
        } else {
          console.error('元素未找到！')
        }
      } else if (data.supports) {
        const accordionContainer = document.getElementById(IdName)
        const allTinySliderGeneral1113ByClass = document.getElementsByClassName('tiny-slider-general-1113')
        data.supports.forEach((support, index) => {
          const isFirst = index === 0
          const accordionItem = document.createElement('div')
          accordionItem.classList.add('border-bottom', 'custom-item', 'pb-3', 'mb-4')
          const header = document.createElement('div')
          header.classList.add('d-flex', 'justify-content-between', 'align-items-center')
          const title = document.createElement('h5')
          title.classList.add('font-weight-bold')
          title.textContent = support.title
          const toggleButton = document.createElement('div')
          toggleButton.classList.add('d-flex', 'justify-content-end', 'align-items-center', 'mt-n1')
          toggleButton.style.height = '40px'
          toggleButton.innerHTML = `
                <a class="d-block text-dark" data-toggle="collapse" data-target="#collapsed${index}" aria-expanded="${isFirst}" aria-controls="collapsed${index}">
                    <i class="fa fa-minus ms-auto"></i>
                    <i class="fa fa-plus ms-auto"></i>
                </a>`
          header.appendChild(title)
          header.appendChild(toggleButton)
          // support Links
          const content = document.createElement('div')
          content.id = `collapsed${index}`
          content.classList.add('collapse', 'gl-rounded', 'mt-0', 'pr-5', 'pl-3')
          if (isFirst) content.classList.add('show')
          content.setAttribute('aria-labelledby', `collapsed${index}`)
          content.setAttribute('data-parent', '#accordion')
          support.links.forEach((link) => {
            const linkItem = document.createElement('p')
            linkItem.classList.add('my-2')

            const anchor = document.createElement('a')
            anchor.href = link.url
            anchor.target = '_blank'
            anchor.innerHTML = `<i class="fa-solid fa-arrow-up-right-from-square mr-1"></i> ${link.text}`
            linkItem.appendChild(anchor)
            content.appendChild(linkItem)
          })
          accordionItem.appendChild(content)
          accordionItem.appendChild(header)
          accordionContainer.appendChild(accordionItem)
        })
        if (allTinySliderGeneral1113ByClass.length > 0 && data.supports.length > 0) {
          const slider = tns({
            container: '.tiny-slider-general-1113',
            loop: true,
            items: 1,
            center: true,
            slideBy: 1,
            nav: false,
            autoplay: true,
            speed: 400,
            autoplayButtonOutput: false,
            autoHeight: true,
            mouseDrag: true,
            controlsContainer: '#tiny-slider-controls-general-1113',
            responsive: {
              640: {
                items: 1
              },
              768: {
                items: 1
              },
              991: {
                items: 2
              },
              1440: {
                items: 3
              }
            }
          })
        }
      }
    }
  }
})
